var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-limit-loan pt-5"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mt-7",attrs:{"cols":"12"}},[_c('Sign',{attrs:{"cameraMode":_vm.cameraMode},on:{"setSignature":(v) => (_vm.userSign = v)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }